.badge {
	padding: 2px 6px;
	background-color: green;
	border-radius: 4px;
	display: flex;
	width: fit-content;
	justify-content: space-between;
	align-items: center;
	gap: 4px;
}

.success {
	background-color: var(--background-success-high);
	color: var(--content-success);
}

.error {
	background-color: var(--background-danger);
	color: var(--content-error);
}

.pending {
	background-color: var(--background-accent-high);
	color: var(--content-accent-high);
}

.info {
	background-color: var(--background-info-high);
	color: var(--content-info);
}
